// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__Pded4","row":"ProcedureTreatmentSummary_row__17y0y"};